import type { ChangeEvent } from 'react';

type SalaryInputProps = {
  setAnnualGrossSalary: (value: string) => void;
  onSubmit: () => void;
  annualGrossSalary: string;
};

export const SalaryInput = ({
  setAnnualGrossSalary,
  onSubmit,
  annualGrossSalary,
}: SalaryInputProps) => {
  const handleChange = ({
    target: { value },
  }: ChangeEvent<HTMLInputElement>) => {
    const castedToNumber = Number(value);

    if (value === '') return setAnnualGrossSalary('');
    if (isNaN(castedToNumber)) return;

    setAnnualGrossSalary(value);
  };

  return (
    <div className="flex flex-col mb-4">
      <label className="text-medium font-medium mb-2.5">
        What’s the gross salary you expect to pay?
      </label>
      <div className="flex w-full flex-wrap gap-[8px]">
        <div className="min-w-1/2 relative flex-1">
          <input
            className="relative z-[1] transition bg-transparent w-full border border-e3 focus:outline-none focus:border-primary rounded-md pl-[68px] h-[52px] text-medium"
            value={annualGrossSalary}
            onChange={handleChange}
            onKeyDown={(e) => {
              if (e.key === 'Enter' && Number(annualGrossSalary)) onSubmit();
            }}
          />
          <span className="text-medium font-medium bg-primaryLight absolute h-full flex items-center justify-center top-0 left-0 w-[60px] rounded-md rounded-r-none">
            USD
          </span>
        </div>
        <button
          className="transition py-3.5 px-7 bg-primary rounded-md disabled:bg-primaryLight active:bg-black"
          disabled={!Number(annualGrossSalary)}
          onClick={onSubmit}
        >
          <span className="text-white font-medium">Calculate costs</span>
        </button>
      </div>
    </div>
  );
};
